import React from 'react'
import { useAppointmentCalendar } from '@context/AppointmentCalendarContext/AppointmentCalendarContext'
import useStyles from './styles'
import { isEmpty } from 'src/utils/isEmpty'

interface ClinicSlotsInfoProps {
  clinicId: string
}

export const ClinicSlotsInfo = ({ clinicId }: ClinicSlotsInfoProps) => {
  const { clinicsInCity } = useAppointmentCalendar()
  const clinic = clinicsInCity.find((clinic) => clinic.referenceId === clinicId)
  const classes = useStyles()

  if (!clinic) return null

  return (
    <div className={classes.clinicInfo}>
      <div className={classes.clinicName}>{clinic.officialName}</div>
      <div className={classes.addresLine}>
        <div className={classes.clinicAddress}>
          {clinic.street} {clinic.houseNumber}
        </div>
        {!isEmpty(clinic.distanceInKm) && (
          <div className={classes.distanceContainer}>
            |<div className={classes.distance}>{clinic.distanceInKm}km</div>
          </div>
        )}
      </div>
    </div>
  )
}
